export function toSemVer(input, throws = true) {
    if (input === null || input === undefined) {
        if (throws) {
            throw new Error("input cannot be null or undefined");
        }
        return undefined;
    }
    const [majorStr, minorStr, patchStr] = input.split(".");
    const major = Number.parseInt(majorStr || "", 10);
    const minor = Number.parseInt(minorStr || "", 10);
    const patch = Number.parseInt(patchStr || "", 10);
    if ([major, minor, patch].indexOf(Number.NaN) !== -1 ||
        ![major, minor, patch].every(Number.isFinite)) {
        if (throws) {
            throw new Error("Invalid semver format");
        }
        return undefined;
    }
    return {
        major,
        minor,
        patch,
    };
}
export function compareSemVer(a, b) {
    if (a === null || a === undefined || b === null || b === undefined) {
        throw new Error("Cannot compare null or undefined semvers");
    }
    if (a.major > b.major) {
        return 1;
    }
    if (a.major < b.major) {
        return -1;
    }
    if (a.minor > b.minor) {
        return 1;
    }
    if (a.minor < b.minor) {
        return -1;
    }
    if (a.patch > b.patch) {
        return 1;
    }
    if (a.patch < b.patch) {
        return -1;
    }
    return 0;
}
export function semVerToString(semVer) {
    return `${semVer.major}.${semVer.minor}.${semVer.patch}`;
}
